import React from 'react';
import { EventsScreen } from '@/components/domain/events/EventsScreen';
import { MemberDetails } from '~/models/MemberDetails';

interface ProfileTabEventsProps {
  member?: MemberDetails;
}

export function ProfileTabEvents({ member }: ProfileTabEventsProps) {
  return <EventsScreen memberId={member?.Id} showHeader={false} />;
}
